import * as React from 'react';
import './CheckBox.css';
import SVG from 'react-inlinesvg';

export interface ICheckBoxProps {
  onClick(): void;
  checked: boolean;
  disabled: boolean;
}

export default (props: ICheckBoxProps) => (
  <span
    className="controlIndicator"
    onClick={() => !props.disabled ? props.onClick() : null}
  >
    {props.checked
      ? <SVG className="checkBoxCheckedImg" src={require('./images/mark.svg')} />
      : null}
  </span>);




// WEBPACK FOOTER //
// ./src/components/CheckBox/CheckBox.tsx